<template>
  <!-- Using components -->
  <b-input-group :prepend="fieldData.script" class="input-group-control" :class="{ 'error': errors.has(fieldData.field_name) || fieldData.has_error }">
    <money
      :ref="fieldData.field_name"
      :disabled="(!!showDisabled())"
      :aria-describedby="`${fieldData.field_name}_describedby`"
      v-model="fieldData.field_value"
      @blur.native="apiRule.present && apiRule.type == 'onchange' ? postRule($event.target.value, fieldData) : ''"
      :maxlength="masked_num_maxlength(fieldData.max_length, field_rules)"
      :id="fieldData.field_name"
      v-bind:class="{'form-control': true, 'error': errors.has(fieldData.field_name) || fieldData.has_error }">
    </money>
      <div>
        <input
        :disabled="(!!showDisabled())"
        v-show="false"
        :name="fieldData.field_name"
        type="text"
        class="form-control input-group-textbox"
        @change="apiRule.present && apiRule.type == 'onchange' ? postRule($event.target.value, fieldData) : ''"
        :maxlength="fieldData.max_length"
        v-model="fieldData.field_value"
        v-validate="field_rules"
        >
      </div>
    <b-input-group-append class="mt-1 mt-sm-0 mt-md-1 mt-xl-0" :class="{ 'locked':(!!showDisabled())}">
    <template v-for="(subItem, subKey) in fieldData.values">
      <b-button :class="{ 'last-btn': fieldData.values.length === (subKey+1), 'error': errors.has(fieldData.field_name) || fieldData.has_error, 'active': getGroupInputStatus(subItem, fieldData) }" :key="subKey" @click.prevent.stop="setGroupValue(subItem.internal_value)" class="qrp-btn-outline input-group-append-btn">{{ subItem.display_value }}</b-button>
    </template>
    </b-input-group-append>
    <span v-bind:class="{'warning fas fa-exclamation-triangle': errors.has(fieldData.field_name)  || fieldData.has_error }"></span>
  </b-input-group>
</template>
<script>
/* eslint-disable */
/* eslint prefer-const: */
/* eslint no-undef:  */
/* eslint no-cond-assign: */
import { mask } from 'vue-the-mask';
import FieldIcon from '../presentational/FieldIcon';
import { inputFieldMixin } from '../../mixins/inputFieldMixin';

export default {
  directives: { mask },
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  props: ['fieldData', 'inputType', 'sendPostRule'],
  data() {
    return {
      field_rules: { required: false }, // Default rule for input validation
      phone_masked_input: '', // Holds the phone masked input value outside of the computed property to avoid an infinite loop
    };
  },
  components: { FieldIcon },
  mixins: [inputFieldMixin],
  methods: {
    /**
     * Get input group button status
    */
    getGroupInputStatus(subItem, formData) {
      if (parseInt(formData.field_value) === parseInt(subItem.internal_value)) {
        return true;
      }
      return false;
    },
    /**
     * set group value to selected button
     */
    setGroupValue(value) {
      this.fieldData.field_value = value;
       if(this.apiRule.present){
        this.postRule(this.fieldData.field_value, this.fieldData);
      }
    },
    /**
     * The validation message overlaps the interactive form element, so it is cleared
     * once the components containing the element is clicked.
     */
    clearMessages() {
      this.fieldData.has_error = false; // Reset API errors to false upon any interaction
      this.errors.remove(this.fieldData.field_name); // Temporarily hide the validation message
    },
    /**
     * Sets the input element's `maxlength`.
     * Masked input elements add comma-delimited characters to numbers. This returns
     * the resulting `maxlength` by using either 1) the maximum valid numeric value,
     * or 2) the non-masked "maxlength" value.
     */
    masked_num_maxlength(originalMaxlength, fieldRules = null) {
      /* eslint radix:  */
      let numerator = parseInt(originalMaxlength);
      let divisor = 3; // Commas delimite once per 3 numeric characters
      let maxlength = numerator; // Start with the non-masked maxlength
      // If available, use the validation rules `max_value` instead
      if (fieldRules && fieldRules.max_value) {
        numerator = fieldRules.max_value;
        divisor = 1000; // Commas delimite once per division of 1,000
        maxlength = numerator.toString().length; // Start with the amount of numeric characters in the max value
      }

      while ((numerator = parseInt(numerator / divisor)) && numerator > 0) {
        maxlength += 1;
      }

      return maxlength;
    },
  },
  watch: {
    'fieldData.field_value': function fieldValue() {
      this.clearMessages();
    },
  },
};
</script>
<style scoped>
.input-group-prepend, .input-group-textbox, .input-group-append-btn{
  height: 30px !important;
}
.input-group-control {
  width: auto !important;
}
/***Overrides default input field styling***/
.input-group input.v-money {
  min-width: 131px;
  max-width: 50%;
  border-top-right-radius: 0rem !important;
  border-bottom-right-radius: 0rem !important;
}
/***Overrides default .btn class padding***/
.input-group-append-btn{
  padding: 0 0.75rem !important;
}
/***Overrides default .btn-secondary:focus class styling***/
.btn:focus, .btn-secondary:focus {
  border-color: #001326;
  z-index: 1;
  -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 51, 102, 0.5) !important;
  box-shadow: 0 0 0 0.2rem rgba(0, 51, 102, 0.5) !important;
  -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 51, 102, 0.5) !important;
  box-shadow: 0 0 0 0.2rem rgba(0, 51, 102, 0.5) !important;
  background-color: transparent !important;
  color: #001326 !important;
}
/***Overrides default .btn-secondary.active class styling***/
.btn-secondary.active:focus {
  border-color: #001326;
  -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 51, 102, 0.5) !important;
  box-shadow: 0 0 0 0.2rem rgba(0, 51, 102, 0.5) !important;
  -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 51, 102, 0.5) !important;
  box-shadow: 0 0 0 0.2rem rgba(0, 51, 102, 0.5) !important;
  background-color: #001326 !important;
  color: #ffffff !important;
}
.input-group-text{
  background-color: #EEEEEE !important;
}
.error .input-group-text, .input-group-control .error, .input-group-append-btn.error {
  border: 1px solid #BB0000 !important;
  box-shadow: inset 0 1px 1px rgba(0,0,0,.05), 0 0 4px rgba(187,0,0,.6);
  border-radius: 0rem !important;
  background: #F5D9D9 !important;
}
.last-btn {
    border-radius: 0rem 0.25rem 0.25rem 0rem  !important;
}
</style>



// WEBPACK FOOTER //
// src/components/interactive/InputGroup.vue?6cbedd50